import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import UserPublicResponseResource from "common/resources/User/UserPublicResponseResource";
import { ensure } from "common/utils/types";
import { capitalize } from "utils/StringUtils";

export const formatUserName = (user: Pick<UserPublicResponseResource , "firstName" | "lastName">) => {
	return `${capitalize(user.firstName)} ${capitalize(user.lastName)}`;
};

export const formatContributorName = (contributor: Pick<ContributorResponseResource, "firstName" | "lastName" | "companyName">, separator = " / ") => {
	const companyName = contributor.companyName ? capitalize(contributor.companyName) : null;
	const personName = ensure(contributor, ["firstName", "lastName"]) ? formatUserName(contributor) : null;

	return [personName, companyName].filter(Boolean).join(separator);
};
